import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createInspection,
  getInspectionByRegistrationId,
  getRallyInspections,
  updateInspection,
} from "./inspections.service";

const key = "jeep-rally-inspections";

export const useGetRallyInspections = (eventId, options = {}) => {
  return useQuery({
    queryKey: [key, "event", eventId],
    queryFn: () => getRallyInspections(eventId),
    enabled: Boolean(eventId) && options.enabled !== false,
    ...options,
  });
};

export const useGetInspectionByRegistrationId = (
  registrationId,
  options = {}
) => {
  return useQuery({
    queryKey: [key, "registration", registrationId],
    queryFn: async () => {
      try {
        return await getInspectionByRegistrationId(registrationId);
      } catch (error) {
        const status = error?.response?.status;
        if (status === 404) return null;
        throw error;
      }
    },
    enabled: Boolean(registrationId) && options.enabled !== false,
    retry: (failureCount, error) => {
      if (error?.response?.status === 404) return false;
      return failureCount < 2;
    },
    ...options,
  });
};

export const useCreateInspectionMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createInspection,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [key] });
      queryClient.invalidateQueries({ queryKey: ["jeep-rally-registrations"] });
    },
  });
};

export const useUpdateInspectionMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ inspectionId, payload }) =>
      updateInspection(inspectionId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [key] });
      queryClient.invalidateQueries({ queryKey: ["jeep-rally-registrations"] });
    },
  });
};
